<template>
  <div class="box">
    <img
      :src="require(`@/assets/images/grandstands/${box.imgSrc}`)"
      class="box_image"
    />
    <div class="box_content">
      <h2 class="box_heading">{{ box.title?.toUpperCase() }}</h2>
      <p class="box_description">{{ box.desc }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: ["box"],
};
</script>

<style lang="scss" scoped>
.box {
  // flex-grow: 1;
  width: 30%;
  max-width: 418px;
  height: 560px;
  background-image: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.17);
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin-top: 20px;
  border-radius: 20px;
  overflow: hidden;
  @media (max-width: 991px) {
    width: calc(50% - 10px);
  }
  @include media_tablet {
    width: 100%;
    max-width: none;
    height: auto;
  }
  &_image {
    flex: 0 1 223px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  &_content {
    padding: 20px;
    height: 337px;
    display: flex;
    flex-direction: column;
    @include media_tablet {
      height: auto;
    }
    h2 {
      font-family: Formula1-Display-Bold;
      font-size: 20px;
      @media (max-width: 1400px) {
        font-size: 17px;
      }

      color: #008e97;
      line-height: 26px;
      font-weight: 500;
    }
    p {
      font-family: TitilliumWeb-Regular;
      font-size: 12px;
      color: #000000;
      line-height: 19px;
      font-weight: 400;
    }
  }
}
</style>